module.exports = __webpack_public_path__ + "img/menu_store.11aa6266.png";